import React from 'react';
import { HeartIcon, FacebookIcon, LinkedinIcon, TwitterIcon, MapPinIcon, PhoneIcon, MailIcon, PrinterIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="contact" className="bg-dark text-white pt-20 pb-10" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16" data-id="element-102">
          {/* Company Info */}
          <div className="space-y-6" data-id="element-103">
            <div className="flex items-center" data-id="element-104">
              <img src="https://cdn.magicpatterns.com/uploads/oV66CvE5T9DxmmC6cXmgrm/ChatGPT_Image_Mar_27__2026__07_43_24_PM-removebg-preview.png" alt="Edvin Home Healthcare Logo" className="h-12 w-12 object-contain mr-3" data-id="element-105" />
              <span className="font-bold text-xl tracking-tight" data-id="element-106">
                Edvin Home Healthcare
              </span>
            </div>
            <p className="text-gray-400 leading-relaxed italic" data-id="element-107">
              "Providing ultimate therapeutic care 24/7"
            </p>
            <div className="flex space-x-4" data-id="element-108">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-109">
                <FacebookIcon className="h-5 w-5" data-id="element-110" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-111">
                <TwitterIcon className="h-5 w-5" data-id="element-112" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-113">
                <LinkedinIcon className="h-5 w-5" data-id="element-114" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-115">
            <h3 className="text-lg font-bold mb-6 border-b border-white/10 pb-2 inline-block" data-id="element-116">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-117">
              <li data-id="element-118">
                <a href="#/" className="text-gray-400 hover:text-white transition-colors block" data-id="element-119">
                  Home
                </a>
              </li>
              <li data-id="element-120">
                <a href="#/about" className="text-gray-400 hover:text-white transition-colors block" data-id="element-121">
                  About Us
                </a>
              </li>
              <li data-id="element-122">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-123">
                  Services
                </a>
              </li>
              <li data-id="element-124">
                <a href="#/resources" className="text-gray-400 hover:text-white transition-colors block" data-id="element-125">
                  Resources
                </a>
              </li>
              <li data-id="element-126">
                <a href="#/faq" className="text-gray-400 hover:text-white transition-colors block" data-id="element-127">
                  FAQs
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-128">
            <h3 className="text-lg font-bold mb-6 border-b border-white/10 pb-2 inline-block" data-id="element-129">
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-130">
              <li data-id="element-131">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-132">
                  In-home Care
                </a>
              </li>
              <li data-id="element-133">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-134">
                  Physical Therapy
                </a>
              </li>
              <li data-id="element-135">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-136">
                  Wound Care
                </a>
              </li>
              <li data-id="element-137">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-138">
                  Respite Care
                </a>
              </li>
              <li data-id="element-139">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-140">
                  Occupational Therapy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-141">
            <h3 className="text-lg font-bold mb-6 border-b border-white/10 pb-2 inline-block" data-id="element-142">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-143">
              <li className="flex items-start" data-id="element-144">
                <PhoneIcon className="h-5 w-5 text-primary mr-3 mt-1 flex-shrink-0" data-id="element-145" />
                <div className="text-gray-400" data-id="element-146">
                  <p data-id="element-147">Cell: (240) 535-8731</p>
                  <p data-id="element-148">Office: (240) 790-6760</p>
                </div>
              </li>
              <li className="flex items-center" data-id="element-149">
                <PrinterIcon className="h-5 w-5 text-primary mr-3 flex-shrink-0" data-id="element-150" />
                <span className="text-gray-400" data-id="element-151">Fax: (240) 303-5680</span>
              </li>
              <li className="flex items-center" data-id="element-152">
                <MailIcon className="h-5 w-5 text-primary mr-3 flex-shrink-0" data-id="element-153" />
                <a href="mailto:edvinhomehealth@gmail.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-154">
                  edvinhomehealth@gmail.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-155">
                <MapPinIcon className="h-5 w-5 text-primary mr-3 mt-1 flex-shrink-0" data-id="element-156" />
                <span className="text-gray-400" data-id="element-157">
                  11075 Berry Road, Suite 301-6
                  <br data-id="element-158" />
                  Waldorf, MD 20603
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm" data-id="element-159">
          <p data-id="element-160">
            &copy; {currentYear} Edvin Home Healthcare Solutions and Nursing
            Services LLC. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 space-x-4" data-id="element-161">
            <a href="#" className="hover:text-white transition-colors" data-id="element-162">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-163">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}